// Win-back, 4 weeks after a lapse — the last one. MARKETING (PECR unsubscribe).

import type { EmailData } from "../../types";
import { b, body, call, esc, p } from "../../layouts/chrome";
import { callCta, plainEmailHtml } from "../../layouts/plain";
import { brand } from "../brand";

export const subject = (_data: EmailData) =>
  `Our final reminder: £25 Amazon voucher when you re-insure with ${brand.name}`;

export const html = (data: EmailData) =>
  plainEmailHtml({
    brand,
    data,
    callNumber: brand.callNumber,
    heading: "Last chance to claim your voucher",
    cta: callCta(brand.callNumber),
    unsubscribeUrl: data.unsubscribeUrl,
    bodyHtml: body(
      p(
        `This is our final reminder about your ${b("£25 Amazon voucher")} — it's yours when you take out a new policy for ${b(`'${esc(data.companyName)}'`)} with ${brand.name}.`,
      ),
      p(
        "If you've found cover elsewhere, no hard feelings — but if anything changes, we're always happy to quote.",
      ),
      p(`Call ${call(brand)} to claim it.`),
      p(
        "£25 Amazon voucher: one per business, issued after your new policy has been active for 30 days. Ask our team for full terms.",
      ),
    ),
  });
